module.exports = __webpack_public_path__ + "static/media/approve_blue.8e1b27c0.svg";